export { default } from "./DeliveryScooterLogo";
